<div class="dialog-content-wrapper fav-icon-dialog-wrapper min-w-3/4 md:min-w-80">
  <mat-toolbar class="mat-primary m-0">
   <mat-toolbar-row fxFlex fxLayout="row" fxLayoutAlign="space-between center" class="flex justify-between">
      <span class="title dialog-title text-xl text-black m-0">Company Security Code</span>
      <button mat-icon-button (click)="matDialogRef.close(['exit', isCompanyCodeVerify])" aria-label="Close dialog">
        <mat-icon>close</mat-icon>
      </button>
    </mat-toolbar-row>
  </mat-toolbar>

  <div mat-dialog-content class="p-2 pb-0 sm:p-3 sm:pb-0 md:p-4 " fusePerfectScrollbar>
    <form [formGroup]="companyCodeForm" class="event-form w-100-p" fxLayout="column" fxFlex>
      <div *ngIf="apiResponseErrorMessage" class="message-box error mb-3">
        <span class="custom-span-pre">{{ apiResponseErrorMessage }}</span>
      </div>

      <div class="w-100-p">
        <label class="font-size-20">Company: {{ data.companyName }}</label>
      </div>

      <mat-form-field class="w-100-p" *ngIf="isCompanySecurityCodeAvailable">
        <input matInput type="password" placeholder="Code" formControlName="code" required>
        <mat-error>
          <span *ngIf="companyCodeForm.get('code').hasError('required')">Company Code is required.</span>
          <span *ngIf="companyCodeForm.get('code').hasError('pattern')">Only numeric values allowed.</span>
          <span
            *ngIf="!companyCodeForm.get('code').hasError('required') && companyCodeForm.get('code').hasError('maxlength')">
            Maximum 4 digits allowed.
          </span>
        </mat-error>
      </mat-form-field>

      <mat-form-field class="w-100-p" *ngIf="!isCompanySecurityCodeAvailable">
        <input matInput type="text" placeholder="Code" [disabled]="true">
      </mat-form-field>
    </form>
  </div>

  <div mat-dialog-actions class="m-0 pt-0 p-3 mat-action-fav flex justify-center gap-3" fxLayout="row" fxLayoutAlign="end center">
    <button *ngIf="isCompanySecurityCodeAvailable" type="submit" class="save-button mat-primary"
      mat-raised-button [disabled]="!companyCodeForm.valid" aria-label="Verify Code" (click)="verifyCompanyCode()">
      Verify Code
    </button>
    <button *ngIf="!isCompanySecurityCodeAvailable" type="submit" class="save-button mat-primary" mat-raised-button
      aria-label="Verify Code" (click)="verifyCompanyCode()">
      Verify Code
    </button>
  </div>
</div>
